import React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import { customAreaCountryCodes } from '@components-shared/forms/PhoneInput/constants';
import { IPhoneInputProps } from '@components-shared/forms/PhoneInput/interfaces';
import '@styles-shared/phoneInput.scss';
import cn from 'classnames';
import { CONSTANTS } from '../../constants';
import { HintMessage } from '../hintMessage';

export const PhoneInput = (props: IPhoneInputProps): JSX.Element => {
  const {
    name,
    title,
    tooltip,
    attributes,
    valid,
    validationMessage,
    value,
    onChange,
    hintMessage,
    preferredCountries,
    defaultCountry,
    required,
    className,
    disableCountryGuess,
  } = props;

  return (
    <InputFieldWrapper
      name={name}
      className={className}
      valid={valid}
      title={title}
      tooltip={tooltip}
      validationMessage={validationMessage}
      required={required}>
      <div className="form__phone-input-container">
        <div className="form__input-container">
          <ReactPhoneInput
            areaCodes={customAreaCountryCodes}
            country={defaultCountry}
            preferredCountries={preferredCountries}
            countryCodeEditable={false}
            disableCountryGuess={disableCountryGuess}
            specialLabel=""
            onChange={(val, data) => onChange(name, val, data)}
            inputClass="form__input"
            containerClass={cn({ invalid: !valid, disabled: attributes.disabled })}
            {...attributes}
            value={value || ''}
            inputProps={{ name, required }}
            enableLongNumbers={CONSTANTS.PHONE_LENGTH}
          />
          {hintMessage && <HintMessage valid={valid} message={hintMessage} />}
        </div>
      </div>
    </InputFieldWrapper>
  );
};
